<template>
  <div class="comReport">
    <div class="modules">
      <div class="topSteps_wrap" ref="personWrap">
        <div class="topSteps" >
        <div class="steps" id="steps1" ref="personTab">
          <img class="steps_t1" :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div class="steps_t2 steps_t2_a">待处理</div>
          <div class="steps_t3">{{details.createdAt}}</div>
          <div v-if="$store.state.common.theme==3" :class="['steps_line',details.repairStatus<2||!details.rprRepairOrderDispatchBeans?'':'steps_line_active_theme_3']"></div>
          <div v-if="$store.state.common.theme!=3" :class="['steps_line',details.repairStatus<2||!details.rprRepairOrderDispatchBeans?'':'steps_line_active']"></div>
        </div>
        <div class="steps" id="steps2">
          <div class="steps_t1_b" v-if="details.repairStatus<2||!details.rprRepairOrderDispatchBeans"></div>
          <img class="steps_t1" v-else :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div :class="['steps_t2',details.repairStatus>1&&details.rprRepairOrderDispatchBeans?'steps_t2_a':'']">已派单</div>
          <div class="steps_t3">{{details.dispatchTime}}</div>
          <div v-if="$store.state.common.theme==3" :class="['steps_line',details.repairStatus<3||!details.arriveTime?'':'steps_line_active_theme_3']"></div>
          <div v-if="$store.state.common.theme!=3" :class="['steps_line',details.repairStatus<3||!details.arriveTime?'':'steps_line_active']"></div>
        </div>
        <div class="steps" id="steps3">
          <div class="steps_t1_b" v-if="details.repairStatus<3||!details.arriveTime"></div>
          <img class="steps_t1" v-else  :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div :class="['steps_t2',details.repairStatus>2&&details.arriveTime?'steps_t2_a':'']">处理中</div>
          <div class="steps_t3">{{details.arriveTime}}</div>
          <div v-if="$store.state.common.theme==3" :class="['steps_line',details.repairStatus<4||!details.finishedTime?'':'steps_line_active_theme_3']"></div>
          <div v-if="$store.state.common.theme!=3" :class="['steps_line',details.repairStatus<4||!details.finishedTime?'':'steps_line_active']"></div>
        </div>
        <div class="steps" id="steps4">
          <div class="steps_t1_b"  v-if="details.repairStatus<4||!details.finishedTime"></div>
          <img class="steps_t1" v-else  :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div :class="['steps_t2',details.repairStatus>3&&details.finishedTime?'steps_t2_a':'']">已完成</div>
          <div class="steps_t3">{{details.finishedTime}}</div>
          <div v-if="$store.state.common.theme==3" :class="['steps_line',details.repairStatus<5?'':'steps_line_active_theme_3']"></div>
          <div v-if="$store.state.common.theme!=3" :class="['steps_line',details.repairStatus<5?'':'steps_line_active']"></div>
        </div>
        <div class="steps" id="steps5">
          <div class="steps_t1_b" v-if="details.repairStatus<5"></div>
          <img class="steps_t1" v-else  :src="require(`../../assets/images/icon_check_${common.theme}.png`)" alt=""/>
          <div :class="['steps_t2',details.repairStatus>4?'steps_t2_a':'']">已关闭</div>
          <div class="steps_t3">{{details.closeTime}}</div>
        </div>
        </div>
      </div>
    </div>
    <!-- <div class="modules" style="margin-bottom:0;">
      <div class="m1_wrap">
        <div class="m1_text1">拜访门禁卡</div>
        <img :src="QRCode" class="m1_icon"/>
        <div class="m1_text2">预约编号：{{visitorOutput.reserveNo}}</div>
      </div>
    </div> -->
    <div class="people">
      <div v-if="item.mainPerson == 1&&item.cancle==1" v-for="(item,index) in details.rprRepairOrderDispatchBeans">
        <div class="people_title">
          负责人
        </div>
        <div class="people_item">
          <img @click="callPhone(item.phoneNo)" class="people_phone" :src="require(`../../assets/images/icon_phone_${common.theme}.png`)" alt=""/>
          <img class="people_icon" src="../../assets/images/repair/img_worker.jpg"></img>
          <div class="people_con">
            <div class="people_con_t1">{{item.workerName}}</div>
            <div class="people_con_t2">{{item.phoneNo}}</div>
          </div>
        </div>
      </div>
      <div v-if="item.mainPerson != 1&&item.cancle==1" v-for="(item,index) in details.rprRepairOrderDispatchBeans">
        <div class="people_title">
          辅助维修工
        </div>
        <div class="people_item">
          <img @click="callPhone(item.phoneNo)" class="people_phone" :src="require(`../../assets/images/icon_phone_${common.theme}.png`)" alt=""/>
          <img class="people_icon" src="../../assets/images/repair/img_worker.jpg"></img>
          <div class="people_con">
            <div class="people_con_t1">{{item.workerName}}</div>
            <div class="people_con_t2">{{item.phoneNo}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="material" v-if="details.rprRepairOrderMaterialBeans">
      <div class="material_title">
        <div class="material_title_1">线上支付费用</div>
        <div class="material_title_2">合计金额:<span class="material_title_2_c"> ￥{{totalAmount}}</span></div>
      </div>
      <div class="material_list" v-for="(item,index) in details.rprRepairOrderMaterialBeans">
        <div class="material_item">
          <img class="material_item_l" v-if="item.materialName=='人工费'" src="../../assets/images/repair/img_cost_labor.jpg"></img>
          <img class="material_item_l" v-else src="../../assets/images/repair/img_cost_material.jpg"></img>
          <div class="material_item_r">
            <div class="material_item_r1">{{item.materialName}}</div>
            <div class="material_item_r2">￥ {{item.price}}</div>
             <div class="material_item_r3">x{{item.count}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="modules">
      <div class="title">
        <span class="modules_title">进度反馈</span>
      </div>
      <div class="item">
        <span class="item_t1">反馈日期</span><span class="item_t2">{{visitorOutput.visitorUserName}}</span>
      </div>
      <div class="item">
        <span class="item_t1">反馈内容</span><span class="item_t2">{{visitorOutput.visitorMobile}}</span>
      </div>
      <div class="item">
        <span class="item_t1">反馈日期</span><span class="item_t2">{{visitorOutput.visitorIdType}}</span>
      </div>
      <div class="item">
        <span class="item_t1">反馈内容</span><span class="item_t2">{{visitorOutput.visitorId}}</span>
      </div>
    </div> -->

    <div class="modules">
      <div class="title">
        <!-- <span class="modules_tag"></span> -->
        <span class="modules_title">报修内容</span>
      </div>
      <div class="item">
        <span class="item_t1">报修单号</span><span class="item_t2">{{details.repairCode}}</span>
      </div>
      <div class="item" v-if="!details.secondType">
        <span class="item_t1">报修类型</span><span class="item_t2">{{details.repairType}}</span>
      </div>
      <div class="item" v-else>
        <span class="item_t1">报修类型</span><span class="item_t2">{{details.repairType+'-'+details.secondType}}</span>
      </div>
      <div class="item">
        <span class="item_t1">报修地点</span><span class="item_t2">{{details.address}}</span>
      </div>
      <div class="item">
        <span class="item_t1">报修时间</span><span class="item_t2">{{details.createdAt}}</span>
      </div>
      <div class="item">
        <span class="item_t1">期望上门时间</span><span class="item_t2">{{details.expectTime}}</span>
      </div>
      <div class="item">
        <span class="item_t1">问题描述</span><span class="item_t2">{{details.remark}}</span>
      </div>
      <div class="item">
        <span class="item_t1"></span>
        <div class="item_t2">
          <div class="showPic" v-for="(item,index) in fileList" :key="item.path" @click="viewImage(item.path,index)">
            <img v-if="item.postfix.indexOf('mp4') == -1 && item.postfix.indexOf('flv') == -1" class="file" :src="item.path" alt="">
            <!-- <video v-else class="file" :src="item.path" autoplay poster="posterimage.jpg">

            </video> -->
          </div>
        </div>
      </div>
    </div>


    <div class="bottomBtn_wrap_h">
    </div>
    <!-- <div class="bottomBtn_wrap" v-if="details.repairStatus!=5">
      <div class="bottomBtn" @click="confirm">关闭工单</div>
    </div> -->

    <div class="bottomBtn_wrap" v-if="(details.repairStatus==5)&&logLength==0&&hasEvaluateButton">
      <div class="bottomBtn" @click="evaluate()">去评价</div>
    </div>
    <div class="bottomBtn_wrap" v-if="(details.repairStatus==5)&&logLength!=0">
      <div class="bottomBtn" @click="viewEvaluate()">查看评价</div>
    </div>
     <!-- 查看大图 -->
  <fade-animation>
    <common-gallary :imgs="arrImgs" :curIndex="curIndex" v-show="showGallary" @close="showGallary=false"></common-gallary>
  </fade-animation>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import { callSpaceUp,spaceUpPcHttp,checkEvaluateButton} from '../../utils/api'
import util from "../../utils/util";
import { mapState } from 'vuex';
import storage from "../../utils/storage";
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
export default {
  name:"details",
  data () {
    return {
      arrImgs:[],
      curIndex:0,
      showGallary:false,
      searchFileUrl:spaceUpPcHttp+'/syscfg/attachmentTerminal/queryAttachmentListByOneData',
      headers: {
        "Access-channel": "saas_rst"
      },
      visitorOutput:{},
      QRCode:'',
      mode:'',
      totalAmount:0,
      details:{},
      fileList:'',
      hex_md5_return:"",
      timemap:"",
      scroll:'',
      logLength:0,
      hasEvaluateButton:false
    };
  },
  components:{
    CommonGallary,
    FadeAnimation
  },
  computed: {
    ...mapState({
      userId: state => state.common.userId,
      common: state => state.common,
    })
  },
  created () {
    // 公钥+私钥+时间戳+平台
    let gong = 'vanke2019spaceup009'
    let si = '009vanke2019spaceup001'
    let platfrom = 'SaasMobile'
    this.timemap = new Date().getTime()
    let str = gong+si+this.timemap+platfrom
    this.hex_md5_return = this.$md5(str)

    this.$nextTick(() => {
     this.personScroll();
    });
    this.fetchData();
    this.searchImages();
    this.fetchCheckEvaluateButton();
  },
  activated() {
    this.fetchData();
    this.searchImages();

  },
  mounted(){

  },
  methods: {
    viewImage(url,index) {
      this.fileList.forEach((item,i)=>{
        if(item.postfix.indexOf('mp4') == -1 && item.postfix.indexOf('flv') == -1){
          this.$set(this.arrImgs,i,item.path)
        }
      })
      this.curIndex = index
      this.showGallary = true
    },
    viewEvaluate(){
      let item = this.details
      this.$router.push(`/evaluate/viewEvaluate?id=${item.id}`);
    },
    evaluate () {
      let item = this.details
      let target = ''
      let targetPhone = ''
      let len = this.details.rprRepairOrderDispatchBeans?this.details.rprRepairOrderDispatchBeans.length:[]
      for (let i = 0; i < len; i++) {
        if(this.details.rprRepairOrderDispatchBeans[i].mainPerson == 1){
          target = this.details.rprRepairOrderDispatchBeans[i].workerName
          targetPhone = this.details.rprRepairOrderDispatchBeans[i].phoneNo
        }
      }
      this.$router.push(`/evaluate/evaluate?id=${item.id}&referenceName=物业报修&templateType=2&referenceNo=${item.repairCode}&myCompanyId=${item.companyId}&target=${target}&targetPhone=${targetPhone}`)
    },
    scrollTo(){
      let id = 'steps'+this.details.repairStatus
      let a = document.querySelector("#"+id)
      this.scroll.scrollToElement(a, 0, 0)
    },
    viewThis(item){
      let self = this;
      storage.set("viewImgList",JSON.stringify(self.fileList))
      let type = item.postfix
      let path = item.path
      if(type.indexOf('png')!=-1||type.indexOf('jpeg')!=-1||type.indexOf('jpg')!=-1){
        this.$router.push(`/viewImage?url=${path}`);
      }else{
        this.$router.push(`/viewVideo?url=${path}`);
      }
    },
    searchImages(){
      let self = this;
      let parmes = {
        'moduleCode': 'FX',
        'target': self.$route.query.id,
        'platform': 'SaasMobile',
        'timestamp': self.timemap,
        'sign':self.hex_md5_return,
        'companyId':self.$route.query.cityId?self.$route.query.cityId:self.common.userInfo.cityId
      }
      let cityId = self.$route.query.cityId?self.$route.query.cityId:self.common.userInfo.cityId
      fetch(self.searchFileUrl+"?moduleCode=FX&target="+self.$route.query.id+"&platform=SaasMobile"+"&timestamp="+self.timemap+"&sign="+self.hex_md5_return+"&companyId="+cityId, {
        method: 'get',
        headers:self.headers
      }).then(response => response.json()).then(res => {
        console.log(res)
        this.fileList = res.data.filter((item,index)=>{return index < 9})
      })
    },
    confirm() {
      let self = this
      util.showModal('','确定要关闭工单吗？',true,'确定',
       function(){
          self.close()
      })
    },
    close() {
      let closeTime = util.formatTime(new Date,9);
      let postInfo = {
         "closeTime":closeTime,
         "createBill":0,
         "publicArea":1,
         "repairId":this.details.id,
         'url':'/property/rstRepair/repairMaterial'
      }
      callSpaceUp(postInfo).then(res => {
        util.hideLoading();
        if(res.res.code==10000){
          util.showToast("关闭成功");
          this.fetchData()
        }
      });
    },
    callPhone(phone) {
      if (phone !== "") {
        window.location.href = "tel:" + phone;
      } else {
        util.showToast("暂无维修工电话");
      }
    },
    getQRCode () {
      let content = {
        qrcode: this.visitorOutput.qrcode
      }
      transformToBase64(content).then(res => {
        if (res.res.code === 10000) {
          this.QRCode = res.body.encodeBase64
        }
      });
    },
    cancel() {
      let self = this;
      util.showModal('温馨提示','确定取消吗？',true,'确定',
         function(){
            self.cancelVisitor();
        }, function(){
            console.log(0)
        })
    },
    //取消预约
   cancelVisitor(){
     let self = this;
      cancelVisitorById({
        "visitorId": this.$route.query.id
      }).then(res => {
        console.log(res)
        if (res.res.code === 10000) {
          self.fetchData();
        }
      })
    },
    fetchCheckEvaluateButton(){
       checkEvaluateButton({
         "templateType": 2
       }).then(res => {
         if (res.res.code === 10000) {
           this.hasEvaluateButton = res.body.hasEvaluateButton
         }
       })
    },
    fetchData(){
      callSpaceUp({
        'id': this.$route.query.id,
        thirdId: this.userId,
        platform : "RST",
        companyId: this.$route.query.marketId?this.$route.query.marketId:this.common.marketInfo.id,
        url: "/property/rstRepair/loadRepairById"
      }).then(res => {
        console.log(res);

         if(res.res.code == 10000){
           this.details = res.body.data
           this.logLength = this.details.logEvaluateContentVoList?this.details.logEvaluateContentVoList.length:0
           this.totalAmount = 0
           let arr = this.details.rprRepairOrderMaterialBeans?this.details.rprRepairOrderMaterialBeans:[]
           for (let i = 0; i < arr.length; i++) {
             this.totalAmount += arr[i].totalAmount
           }
           this.scrollTo();
           // this.visitorOutput = res.body.visitorOutput
           // this.getQRCode()
         }

      })
    },
    personScroll() {
      // 默认有六个li子元素，每个子元素的宽度为120px
      let width = 10 * 120;
      this.$refs.personTab.style.width = width + "px";
      // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.personWrap, {
            startX: 0,
            click: true,
            scrollX: true,
            // 忽略竖直方向的滚动
            scrollY: false,
            eventPassthrough: "vertical",
            bounce: true,
          });

        } else {
          this.scroll.refresh();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.comReport {
  background:rgba(238,238,238,1);
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  .modules{

    margin-bottom: 14px;
    padding: 28px;
    box-sizing: border-box;
    background: #ffffff;
    .topSteps_wrap{
      width: 100%;
      overflow-x: hidden;
    }
    .m0_wrap,.statusBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      .status_line{
        margin-bottom: 10px;
      }
      .success{
        width: 32px;
        height: 32px;
        margin: 10px;
      }
      .line_icon{
        width: 16px;
        height: 16px;
        margin: 18px;
        border-radius: 50%;
        background:rgba(218,218,218,1);
      }
      .line{
        display: inline-block;
        width: 186px;
        height: 2px;
        border-top:2px solid #1740da;
        margin: 25px 0
      }
      .text{
        width: 136px;
        line-height: 28px;
        color:rgba(153,153,153,1);
      }
      .text2{
        margin-bottom: 10px;
      }
      .line2{
        width: 124px;
      }
      .line3{
        width: 84px;
      }
      .statusIcon{
        width: 100px;
        height: 100px;
        margin-bottom: 20px;
      }
      .statusText{
        text-align: center;
        color:rgba(102,102,102,1);
        font-size: 28px;
      }
    }
    .m1_wrap{
      display: flex;
      flex-direction: column;
      align-items: center;
      .m1_text1{
        height:28px;
        font-size:24px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:28px;
        margin-bottom: 28px;
      }
      .m1_icon{
        width: 320px;
        height: 320px;
        margin-bottom: 28px;
        background: #f3f4f6;
      }
      .m1_text2{
        font-size:28px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
      }
    }

    .title{
      display: flex;
      margin-bottom: 28px;
      .modules_tag{
        display: inline-block;
        width: 6px;
        height: 24px;
        margin: 10px 12px 12px 0;
        background:rgba(23,64,218,1);
      }
      .modules_title{
        height:44px;
        font-size:32px;
        font-family:PingFangSC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:44px;
      }
    }
    .item{
      display: flex;
      margin-bottom: 20px;
      .item_t1,.item_t2{
        min-width:160px;
        font-size:26px;
        font-family:PingFangSC;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:36px;
        margin-right: 36px;
      }
      .item_t2{
        color:rgba(51,51,51,1);
        margin-right: 0px;
        display: flex;
        flex-wrap: wrap;
      }
      .showPic{
        width: 120px;
        height: 120px;
        border-radius: 8px;
        margin-right: 14px;
        margin-bottom:14px;
        .file{
          width: 120px;
          height: 120px;
          border-radius: 8px;
          display: block;
        }
      }
    }

  }
  .bottomBtn_wrap_h{
    height:108px;
  }
  .bottomBtn_wrap{
    height:108px;
    background:rgba(255,255,255,1);
    position: fixed;
    left: 0;right:0;
    padding:0 28px;
    box-sizing: border-box;
    bottom: 0;
    .bottomBtn{
      width:100%;
      height:76px;
      background:rgba(23,64,218,1);
      border-radius:4px;
      text-align: center;
      line-height: 76px;
      font-size:32px;
      color:rgba(255,255,255,1);
      margin: 16px 0;
    }
  }

.people{
  margin-bottom: 14px;
  .people_title{
    padding: 0 40px;
    box-sizing: border-box;
    font-size:24px;
    font-family:PingFangSC-Regular,PingFangSC;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:56px;
    text-align: left;
  }
  .people_item{
    height: 156px;
    display: flex;
    padding: 28px;
    box-sizing: border-box;
    align-items: center;
    background: #fff;
    position: relative;
    .people_phone{
      position: absolute;
      width: 32px;
      height: 32px;
      right: 40px;
      top: 62px;
    }
    .people_icon{
      width:100px;
      height:100px;
      border-radius: 50%;
      margin-right: 28px;
      background: #f3f4f6;
    }
    .people_con_t1{
      height:28px;
      font-size:28px;
      font-family:PingFangSC-Medium,PingFangSC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height: 28px;
      margin-bottom: 26px;
    }
    .people_con_t2{
      height:28px;
      font-size:28px;
      font-family:PingFangSC-Regular,PingFangSC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:28px;
    }
  }
}
 //进度
 .topSteps{
  width: 1090px;
  height: 178px;
  background: #fff;
  display: flex;
  justify-content: center;
  padding:14px 0 0;
  box-sizing: border-box;
}
.steps{
  width: 218px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative
}
.steps_line{
 position: absolute;
 height: 1px;
 width: 154px;
 border-bottom: 1px solid #F4F4F4;
 top: 23px;
 right:-74px;
}
.steps_line_active{
 border-bottom: 1px solid #1740DA;
}
.steps_line_active_theme_3{
  border-bottom: 1px solid #A1805D;
}
.steps_t1{
  width: 46px;
  height: 46px;
  border-radius: 50%;
  margin: 0 86px 10px;
}
.steps_t1_b{
  width: 16px;
  height: 16px;
  margin: 15px 101px 25px;
  border-radius: 50%;
  background: #C8C8C8;
}
.steps_t2{
  height:36px;
  font-size:26px;
  font-family:PingFangSC;
  font-weight:400;
  color:#999999;
  line-height:36px;
  margin-bottom: 6px;
  text-align: center
}
.steps_t2_a{
  color: #333333;
}
.steps_t3{
  width:136px;
  font-size:20px;
  font-family:PingFangSC;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:28px;
  text-align: center
}
.material{
  padding: 0 28px;
  box-sizing: border-box;
  background: #fff;
  margin-bottom: 14px;
  overflow: hidden;
  .material_title{
    height: 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .material_title_1,.material_title_2,.material_title_2_c{
      font-size:32px;
      font-family:PingFangSC-Medium,PingFangSC;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    .material_title_2{
      font-family:PingFangSC-Regular,PingFangSC;
      font-weight:400;
    }
    .material_title_2_c{
      color: #FC3F56;
      font-family:PingFangSC-Regular,PingFangSC;
      font-weight:400;
    }
  }
  .material_list{
   .material_item{
     margin-bottom: 40px;
     display: flex;
     overflow: hidden;
     .material_item_l{
       width: 120px;
       height: 120px;
       margin-right: 20px;
     }
     .material_item_r1{
        height:28px;
        font-size:24px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:28px;
        margin-bottom: 20px;
     }
     .material_item_r2{
        height:28px;
        font-size:24px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(51,51,51,1);
        line-height:28px;
        margin-bottom: 16px;
     }
     .material_item_r3{
        height:28px;
        font-size:24px;
        font-family:PingFangSC-Regular,PingFangSC;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:28px;
     }
   }
  }
}
}
</style>
